import * as React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Col, Row } from "react-bootstrap";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData } from "../Components/Utilities";
import SelectButtonFormat from "../../Landing/Components/FormOptions/SelectButtonFormat";
export const Category = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [defaultRows, setDefaultRows] = useState(20);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const defaultValues = {
    status: 1,
    groupname: "",
    sort: "",
  };
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "groupname",
      header: "عنوان",
    },
    { field: "sort", header: " اولویت" },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];

  const schema = yup.object({
    groupname: yup
      .string()
      .required("عنوان گروه انتخاب نشده است.")
      .min(3, "نام گروه نباید کمتر از 3 کاراکتر باشد"),
  });

  const {
    handleSubmit,
    reset,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    let status;
    if (data?.Fstatus) {
      status = 1;
    } else {
      status = 0;
    }

    const bodyFormData = new FormData();
    // bodyFormData.append('flink', data?.Flink)
    bodyFormData.append("groupname", data?.groupname);
    // bodyFormData.append('ficon', data?.Ficon)
    bodyFormData.append("sort", data?.sort);
    bodyFormData.append("status", status);

    let cmd = "creategroup";
    if (selectedUserId) {
      bodyFormData.append("groupid", selectedUserId);
      cmd = "updategroup";
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.code === 1) {
          SweetAlert({
            title: "",
            text: "دسته بندی  با موفقیت ذخیره شد.",
            type: "success",
          });
        } else if (responseGlobal?.data?.code === 0) {
          SweetAlert({
            title: "",
            text: "دسته بندی تکراری می باشد.",
            type: "error",
          });
        }
        fetchData("grouplist", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel private route Error: ", error.message);
    }
  };
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("grouplist", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setPageData(data?.dt);
  };
  const handleOpeEditItem = (data) => {
    console.log(data);
    setShowEditComponent(true);
    if (data) {
      setIsEditMode(true);
      setSelectedUserId(data?.catid);
      reset({ ...defaultValues, ...data });
    } else {
      reset(defaultValues);
      setIsEditMode(false);
    }
  };
  const toast = useRef(null);
  const stOptions = [
    { label: "فعال", value: 1 },
    { label: "غیرفعال", value: 0 },
  ];
  return (
    <PanelContainer title={"افزودن/ ویرایش گروه بندی ها"}>
      <div className="row text-right p-md-5 p-sm-0 data-table">
        <Toast ref={toast} />
        <ConfirmDialog />
        <DataTableTemplate
          lazyState={lazyState}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
        />
        <div className="col-6">
          <Button className="" onClick={() => handleOpeEditItem()}>
            افزودن
          </Button>
        </div>
      </div>
      {showEditComponent && (
        <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
          <div className="panel-heading prime-bg text-white text-center py-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش گروه" : "افزودن گروه جدید"}
            </span>
          </div>
          <div className="panel-body">
            <Row>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="groupname"
                  type={"text"}
                  label="عنوان "
                  errors={errors}
                  required={true}
                />
              </Col>

              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="sort"
                  type={"tel"}
                  defaultValue={""}
                  label="اولویت"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                {/* <CheckboxFormat
                  control={control}
                  name="status"
                  errors={errors}
                  type="checkbox"
                  label="وضعیت نمایش"
                /> */}
                  <div className="d-flex flex-direction-column justify-content-start gap-2">
                    <Form.Label className="fw-bold pb-1">وضعیت</Form.Label>
                    <SelectButtonFormat
                      name={"status"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
              </Col>
              <Col className=" col-12 col-lg-6">
                <Button type="submit">ذخیره</Button>
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </PanelContainer>
  );
};
